import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo } from 'react';
import useZipCodeFromUser from 'global-state/zipCodeFromUser/useZipCodeFromUser';
import useIsZipCodeServiceable from 'hooks/useIsZipCodeServiceable';
import useUserLocationFromZipcode from 'hooks/useUserLocationFromZipcode';
import useWarehouseIdForZipCode from 'hooks/useWarehouseIdForZipCode';
import useSetIsZipCodeFromUserServiceable from 'global-state/isZipCodeFromUserServiceable/useSetIsZipCodeFromUserServiceable';
import useSetZipCodeFromUserError from 'global-state/zipCodeFromUserError/useSetZipCodeFromUserError';

// This hook is used to get the user's location from the zip code that they have
// entered into one of the zip code fields in the Consumer app. The values are
// returned in a standard format to allow the useRefreshUserLocation hook to
// return the best available location for the user.
const useLocationForUserZipCode = () => {
  const $ = _c(22);
  const zipCodeFromUser = useZipCodeFromUser();
  const {
    isZipCodeServiceable,
    nonServiceableZipCodeError,
    loading: isZipCodeServiceableLoading
  } = useIsZipCodeServiceable(zipCodeFromUser);
  const setZipCodeFromUserError = useSetZipCodeFromUserError();
  let t0;
  let t1;
  if ($[0] !== nonServiceableZipCodeError || $[1] !== setZipCodeFromUserError) {
    t0 = () => {
      setZipCodeFromUserError(nonServiceableZipCodeError ?? null);
    };
    t1 = [nonServiceableZipCodeError, setZipCodeFromUserError];
    $[0] = nonServiceableZipCodeError;
    $[1] = setZipCodeFromUserError;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  const setIsZipCodeFromUserServiceable = useSetIsZipCodeFromUserServiceable();
  let t2;
  let t3;
  if ($[4] !== isZipCodeServiceable || $[5] !== isZipCodeServiceableLoading || $[6] !== setIsZipCodeFromUserServiceable) {
    t2 = () => {
      if (!isZipCodeServiceableLoading) {
        setIsZipCodeFromUserServiceable(isZipCodeServiceable);
      }
    };
    t3 = [isZipCodeServiceable, isZipCodeServiceableLoading, setIsZipCodeFromUserServiceable];
    $[4] = isZipCodeServiceable;
    $[5] = isZipCodeServiceableLoading;
    $[6] = setIsZipCodeFromUserServiceable;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  const {
    location: locationForUserZipCode,
    errorMessage: locationError,
    loading: isLocationLoading
  } = useUserLocationFromZipcode(isZipCodeServiceable ? zipCodeFromUser : undefined);
  const {
    error: warehouseIdError,
    loading: isWarehouseIdLoading,
    warehouseId
  } = useWarehouseIdForZipCode(isZipCodeServiceable ? zipCodeFromUser : undefined);
  const shouldUseLocation = !!zipCodeFromUser && isZipCodeServiceable && !locationError && !warehouseIdError;
  let t4;
  bb0: {
    if (!shouldUseLocation) {
      t4 = undefined;
      break bb0;
    }
    let t5;
    if ($[9] !== locationForUserZipCode) {
      t5 = locationForUserZipCode ?? {};
      $[9] = locationForUserZipCode;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    const {
      city,
      country,
      state,
      stateShortName,
      zip
    } = t5;
    let t6;
    if ($[11] !== city || $[12] !== country || $[13] !== state || $[14] !== stateShortName || $[15] !== zip) {
      t6 = {
        city,
        country,
        state,
        stateShortName,
        zip
      };
      $[11] = city;
      $[12] = country;
      $[13] = state;
      $[14] = stateShortName;
      $[15] = zip;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    t4 = t6;
  }
  const location = t4;
  const t5 = zipCodeFromUser ? isLocationLoading || isWarehouseIdLoading : false;
  const t6 = shouldUseLocation ? location : undefined;
  const t7 = shouldUseLocation ? warehouseId : undefined;
  let t8;
  if ($[17] !== shouldUseLocation || $[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t8 = {
      isLoading: t5,
      location: t6,
      shouldUseLocation,
      warehouseId: t7
    };
    $[17] = shouldUseLocation;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};
export default useLocationForUserZipCode;